import React from 'react';
import { WorkforceGroupStaffTable } from '@scheduling/components';
import { Gutter } from '@common/components';
import { FiltersType } from '@common/hooks';

export function AdminWorkforceGroupStaff({
  workforceGroupId,
  onFiltersChange,
}: {
  workforceGroupId: string;
  onFiltersChange?: (filters: FiltersType) => void;
}) {
  return (
    <>
      <Gutter>
        <WorkforceGroupStaffTable
          workforceGroupId={workforceGroupId}
          onFiltersChange={onFiltersChange}
        />
      </Gutter>
    </>
  );
}
